import axios from "axios";
import { emitUpgradePrompt } from "@/lib/upgradePrompt";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-surface the Upgrade modal on any 402 that carries the
// `upgrade_required` free-tier gate payload. Individual callers can
// still catch the error and layer on their own UX.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;
      if (status === 402 && detail && (detail.code === "upgrade_required" || detail.code === "trial_expired")) {
        emitUpgradePrompt(detail);
      }
    } catch (interceptorErr) {
      // Never let interceptor break the flow — but log so silent
      // failures don't hide upgrade-prompt regressions.
      console.warn("api 402 interceptor threw", interceptorErr);
    }
    return Promise.reject(err);
  },
);

export default api;
